/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import { AppBar, Toolbar, IconButton, Typography, Box, Menu, MenuItem, Avatar, List, Divider, useTheme, Tooltip } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import { AccountCircle } from '@mui/icons-material'
import BasicModal from './modals/BasicModal.js'
import { auth, db } from '../firebase.js'
import { collection, getDocs, where, query, doc, updateDoc, addDoc, serverTimestamp } from 'firebase/firestore'
import { signOut } from 'firebase/auth'
import { useNavigate } from 'react-router-dom'
import GameListItem from './GameListItem.js'
import TextInput from '../components/TextInput.js'
import LoginModal from './modals/LoginModal.js'
import p4pLogo from '..//assets/images/P4P_logo.png'
import i4sLogo from '..//assets/images/I4S_logo_circ.png'
import { PropTypes } from 'prop-types'

const Appbar = ({ playerName }) => {
  const theme = useTheme()
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false)
  const [isCloseGameModalOpen, setIsCloseGameModalOpen] = useState(false)
  const [isCreateGameModalOpen, setIsCreateGameModalOpen] = useState(false)
  const [games, setGames] = useState([])
  const navigate = useNavigate()
  const isLoggedIn = !!auth.currentUser

  // Determine user logo
  const userLogo = i4sLogo

  function getDisplayStyle (isSomething) {
    return isSomething ? {} : { display: 'none' }
  }
  const isAdmin = !!auth.currentUser?.admin
  const showAdminComponentStyle = getDisplayStyle(isAdmin)
  const showUserComponent = getDisplayStyle(isLoggedIn)

  // opens and closes Menu
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleCloseMenu = () => {
    setAnchorEl(null)
  }
  // Menu Button Logout
  const handleLogout = () => {
    signOut(auth).then(() => {
      localStorage.removeItem('readCount')
      navigate('/')
      console.log('Sign out successful')
    })
      .catch((error) => {
        console.error('Error signing out: ', error)
      })
  }
  // Login Modal
  const openLoginModal = () => {
    setIsLoginModalOpen(true)
  }

  // Create Game Modal
  const openCreateGameModal = () => {
    setIsCreateGameModalOpen(true)
  }

  const createGame = async (input) => {
    try {
      await addDoc(collection(db, 'games'), {
        name: input,
        active: true,
        createdAt: serverTimestamp(),
        turn: 0
      })
      closeModals()
    } catch (err) { console.error(err) }
  }

  // Close Game Modal
  const openCloseGameModal = () => {
    // fetches active games that can be closed
    const fetchGames = async () => {
      const gamesColRef = collection(db, 'games')
      const q = query(gamesColRef, where('active', '==', true))
      const gamesSnap = await getDocs(q)
      setGames(gamesSnap.docs.map(doc => (
        {
          id: doc.id,
          ...doc.data()
        })
      ))
    }
    fetchGames()
    setIsCloseGameModalOpen(true)
    setAnchorEl(null)
  }

  const closeGame = async (selectedGameId) => {
    try {
      const docRef = doc(db, 'games', selectedGameId)
      await updateDoc(docRef, {
        active: false
      })
    } catch (error) {
      console.error('Error joining the game:', error)
    }
    setIsCloseGameModalOpen(false)
  }

  const closeModals = () => {
    setIsLoginModalOpen(false)
    setIsCloseGameModalOpen(false)
    setIsCreateGameModalOpen(false)
  }

  return (
    <>
    <Box>
      <AppBar position='fixed' elevation= {3}
      sx={{
        height: '64px',
        [theme.breakpoints.down('sm')]: {
          height: '56px'
        }
      }}>
        <Toolbar sx={{ display: 'flex', bgcolor: '#fefefe' }}>
          <Box sx={{ display: 'flex', flex: { xs: 0, md: 1 }, justifyContent: 'center' }}>
            <Box sx={{ mr: 'auto', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <IconButton
                size="large"
                edge="start"
                color="primary"
                aria-label="menu"
                sx={ { ...showUserComponent, ...{ mr: 2 } } }
                onClick={handleClick}
                >
                <MenuIcon />
            </IconButton>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleCloseMenu}
              MenuListProps={{
                'aria-labelledby': 'basic-button'
              }}
            >
              <MenuItem sx={ showAdminComponentStyle } onClick={() => { navigate('/') }} >Lobby</MenuItem>
              {/* <MenuItem sx={ showAdminComponentStyle } onClick={() => { navigate('/list') }} >List Prompts</MenuItem>
              <MenuItem sx={ showAdminComponentStyle } onClick={() => { navigate('/update') }} >Update Prompt</MenuItem>
              <MenuItem sx={ showAdminComponentStyle } onClick={() => { navigate('/upload') }} >Upload SIP</MenuItem> */}
              <MenuItem sx={ showAdminComponentStyle } onClick={openCreateGameModal} >Create Game</MenuItem>
              <MenuItem sx={ showAdminComponentStyle } onClick={openCloseGameModal} >Close Game</MenuItem>
              <MenuItem onClick={handleLogout} >Logout</MenuItem>
            </Menu>
            </Box>
          </Box>
          <Box sx={{ display: { xs: 'none', md: 'flex' }, flex: 1, justifyContent: 'center' }}>
            <Box sx={{ flex: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'center' }}>
              <img src={p4pLogo} alt='Peacegame Logo' style={{ width: '100px', height: '90%', objectFit: 'fill', display: 'block' }} />
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
            { isLoggedIn
              ? <Box sx={ { display: 'flex', ml: 'auto', alignItems: 'center' } }>
                    <Typography variant="h6" color="black" sx={{ mr: '5px' }}>
                    {playerName}
                    </Typography>
                    <Avatar alt="User Logo" src={userLogo} />
                </Box>
              : <Tooltip title={'Sign In'}>
                <IconButton
                size='large'
                aria-label='Login Button'
                aria-haspopup="true"
                onClick={openLoginModal}f
                color='primary'
                sx={{ ml: 'auto' }}
                >
                  <AccountCircle />
                </IconButton>
                </Tooltip>
                }
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
    <LoginModal isOpen={isLoginModalOpen} handleClose={closeModals}>
    </LoginModal>
    <BasicModal isOpen={isCloseGameModalOpen} handleClose={closeModals} title={'Select Game To Close It'}>
      <List>
            {games.map((game) => (
              <>
              <GameListItem key={game.id} gameId={game.id} gameName={game.name} createdAt={game.createdAt} buttonLabel={'Close Game ❌'} handleSubmit={closeGame}></GameListItem>
              <Divider/>
              </>
            ))}
      </List>
    </BasicModal>
    <BasicModal isOpen={isCreateGameModalOpen} handleClose={closeModals} title={'Create a Game'} >
      <TextInput inputLabel={'Name'} buttonLabel={'Create Game'} handleSubmit={createGame}/>
    </BasicModal>
    </>

  )
}

Appbar.propTypes = {
  playerName: PropTypes.string
}

export default Appbar
